import React from 'react'
import PropTypes from 'prop-types'

const MAX_RATING = 5
const STAR_INDEXES = Array.from({ length: MAX_RATING }, (_, index) => index)

// How much of the star at `index` is filled, in the quarters the widget's star icons come in.
const starFill = (rating, index) => Math.round(Math.min(Math.max(rating - index, 0), 1) * 4) * 25

// The REVIEWS.io widget's star markup
const Stars = ({ rating }) => (
  <div className='R-RatingStars R-RatingStars--sm u-marginBottom--xs'>
    <div
      className='R-RatingStars__stars u-marginBottom--none'
      role='img'
      aria-label={`${rating} out of ${MAX_RATING} stars`}
    >
      {STAR_INDEXES.map((index) => {
        const fill = starFill(rating, index)
        return <i key={index} className={`stars__icon stars__icon--${fill} ricon-percentage-star--${fill}`} />
      })}
    </div>
  </div>
)

Stars.propTypes = {
  rating: PropTypes.number.isRequired,
}

export default Stars
